
import { getClientData } from '@/api/system-manage/index'

// const modules =
//     require.context('@/components/', true, /\.vue$/)

// 整理路由
function formatRouter(routes) {
  const obs = function(_data) {
    for (let i = 0; i < _data.length; i++) {
      const item = _data[i]

      item['path'] = item.F_UrlAddress ? item.F_UrlAddress : ''
      item['name'] = item.F_UrlAddress ? item.F_UrlAddress : ''
      // item['component'] = () =>
      //     import (`@/components/${item.F_Description}`);
      item['meta'] = {
        title: item.F_FullName,
        icon: item.F_Icon
      }

      if (item.ChildNodes && item.ChildNodes.length > 0) {
        item['children'] = item.ChildNodes
        formatRouter(item.ChildNodes)
      }
    }
  }
  obs(routes)
  return routes
}

const systemManage = {
  namespaced: true,
  state: {
    organize: null,
    role: null,
    duty: null,
    authorizeMenu: null,
    roleTypeMapInfo: null,
    certificate: null,
    unitInfo: null
  },
  mutations: {
    // eslint-disable-next-line no-shadow
    AUTHOR_MENUS: (state, authorizeMenu) => {
      state.authorizeMenu = authorizeMenu
    },
    // eslint-disable-next-line no-shadow
    ORGANIZE_MAP_INFO: (state, organize) => {
      state.organize = organize
    },
    // eslint-disable-next-line no-shadow
    ROLE_MAP_INFO: (state, role) => {
      state.role = role
    },
    // eslint-disable-next-line no-shadow
    DUTY_MAP_INFO: (state, duty) => {
      state.duty = duty
    },
    // eslint-disable-next-line no-shadow
    ROLE_TYPE_MAP_INFO: (state, role) => {
      state.roleTypeMapInfo = role
    },
    // certificate
    // eslint-disable-next-line no-shadow
    CERTIFICATE_MAP_INFO: (state, certificate) => {
      state.certificate = certificate
    },
    // eslint-disable-next-line no-shadow
    UNIT_INFO: (state, unitInfo) => {
      state.unitInfo = unitInfo
    }

  },
  actions: {

    async setSystemManageAction({ commit }) {
      const res = await getClientData({
        type: 1
      })
      const {
        organize,
        role,
        duty,
        authorizeMenu,
        dataItems: { RoleType, Certificate, UnitSpan }
      } = res

      if (!res.authorizeMenu) {
        return
      }

      const route = formatRouter(JSON.parse(authorizeMenu))
      const _homeRoute = {
        path: '/home',
        name: 'Home',
        redirect: {
          name: 'light-map-index'
        },
        children: route // 真正存在的路由
      }
      console.log(_homeRoute)
      // 处理后台路由完毕
      commit('AUTHOR_MENUS', _homeRoute)

      commit('ORGANIZE_MAP_INFO', organize)
      commit('ROLE_MAP_INFO', role)
      commit('DUTY_MAP_INFO', duty)
      commit('ROLE_TYPE_MAP_INFO', RoleType)
      commit('CERTIFICATE_MAP_INFO', Certificate)
      commit('UNIT_INFO', UnitSpan)
    },
    setAuthMenusAction({ commit }, authorizeMenu) {
      commit('AUTHOR_MENUS', authorizeMenu)
    },
    setOrganizeAction({ commit }, organize) {
      commit('ORGANIZE_MAP_INFO', organize)
    },
    setRoleMapInfoAction({ commit }, role) {
      commit('ROLE_MAP_INFO', role)
    },
    setDutyMapInfoAction({ commit }, duty) {
      commit('DUTY_MAP_INFO', duty)
    }
  }
}

export default systemManage
